<template>
  <div class="staffRequirementSubmissionCreate">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'staffRequirementSubmission', params: {} }"
      >
        Staff Submissions
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :to="{ name: 'staffRequirementSubmissionCreate', params: {} }"
      >
        New Submission
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title>New Submission</v-card-title>
      <v-card-text>
        <staff-requirement-submission-form :staffId="staffId" :requirements="requirements"></staff-requirement-submission-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
const StaffRequirementSubmissionForm = () => import("@/components/staffRequirementSubmission/StaffRequirementSubmissionForm.vue");

export default {
  name: "staffRequirementSubmission",
  components: {
    StaffRequirementSubmissionForm
  },
  data: () => {
    return { 
      staffId: null,
      requirements: null
    }
  },
  created() {
    this.staffId = this.$route.query.staffId;
    this.requirements = this.$route.query.requirements;
    this.$emit("showParent", false);
  }
};
</script>
